import { gql } from '@/__generated__';
import { type GetNotificationsQuery } from '@/__generated__/graphql';

export type Notification = GetNotificationsQuery['notificationsConnection']['items'][number];
export type NotificationEntity = Notification['notificationObject']['entity'];

const GET_NOTIFICATIONS = gql(`#graphql
  query GetNotifications($filter: NotificationsFilter, $pagination: CursorPaginationInput) {
    notificationsConnection(filter: $filter, pagination: $pagination) {
      items {
        id
        status
        updatedAt
        notificationObject {
          id
          status
          entity {
            __typename
            ... on Announcement {
              id
              title
              createdAt
              description
            }
            ... on AlertNotification {
              id
              configuration
              message
              device {
                id
                profile {
                  name
                }
              }
            }
          }
        }
      }
      pageInfo {
        totalCount
        nextCursor
        limit
      }
    }
  }
`);

export default GET_NOTIFICATIONS;
